import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Discover = lazy(() => import("@/pages/Discover"));
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
export const Route = createFileRoute("/dashboard")({
  component: () => (
    <ProtectedRoute>
      <Discover />
    </ProtectedRoute>
  ),
});
